import { createEffect, createStore } from 'effector';
import { DiContainer } from '@@/di/di-container';
import { DlpService } from '../services/dlp.service';
import {
  ConsentItem,
  DerivedLot,
  DlpElevator,
  DlpLot,
  GrainSegment,
  LabSegment,
  MixStep,
} from '../ts';

const svc = () => DiContainer.get(DlpService);

export const fetchLotsFx = createEffect((): Promise<DlpLot[]> => svc().getLots());
export const fetchElevatorsFx = createEffect((): Promise<DlpElevator[]> => svc().getElevators());
export const fetchDerivedFx = createEffect((): Promise<DerivedLot[]> => svc().getDerived());
export const fetchMySegmentsFx = createEffect((): Promise<GrainSegment[]> => svc().getMySegments());
export const fetchConsentsFx = createEffect((): Promise<ConsentItem[]> => svc().getConsents());
export const fetchLabSegmentsFx = createEffect((): Promise<LabSegment[]> => svc().getLabSegments());
export const fetchMixStepsFx = createEffect((): Promise<MixStep[]> => svc().getMixSteps());

export const $lots = createStore<DlpLot[]>([]).on(fetchLotsFx.doneData, (_, d) => d || []);
export const $elevators = createStore<DlpElevator[]>([]).on(fetchElevatorsFx.doneData, (_, d) => d || []);
export const $derived = createStore<DerivedLot[]>([]).on(fetchDerivedFx.doneData, (_, d) => d || []);
export const $mySegments = createStore<GrainSegment[]>([]).on(fetchMySegmentsFx.doneData, (_, d) => d || []);
export const $consents = createStore<ConsentItem[]>([]).on(fetchConsentsFx.doneData, (_, d) => d || []);
export const $labSegments = createStore<LabSegment[]>([]).on(fetchLabSegmentsFx.doneData, (_, d) => d || []);
export const $mixSteps = createStore<MixStep[]>([]).on(fetchMixStepsFx.doneData, (_, d) => d || []);
